
export const MyVesselsRouteConstants = {
    Dashboard: "",
    RfiCorrespondence: "rfi-correspondence",
    AllTasks: "all-tasks",
    SubmitCloseOutInformation: "submit-close-out-information",
    SelectVessel: "select-vessel",
    AddPsc: "add-psc",
    DocumentRequirements: "document-requirements",
    VesselDocuments: "vessel-documents",
}